import {DASHBOARD, HELP, NOTIFICATIONS} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {lazy} from 'react'
import {AccountingRoutes} from './accounting.routes'
import {PayablesRoutes} from './payables.routes'
import {SettingsRoutes} from './settings.routes'
import {ReportsRouting} from './reports.routes'

const Error404 = lazy(() => import('pages/errors/ErrorsPage'))

export const AppRouteList: IAppRoutes[] = [
  {
    link: DASHBOARD,
    element: lazy(() => import('pages/dashboard/DashboardWrapper')),
  },
  {
    link: HELP,
    element: lazy(() => import('pages/help/HelpPage')),
  },
  {
    // In-app notifications — reached from the topbar bell's "View all", not the sidebar.
    // Deliberately ungated: the feed is already scoped in SQL to the caller's own user_id,
    // so every user may open their own notifications.
    link: NOTIFICATIONS,
    element: lazy(() => import('@modules/notification/NotificationList')),
  },
  {...AccountingRoutes},
  {...PayablesRoutes},
  {...ReportsRouting},
  {...SettingsRoutes},
  {
    link: 'auth/*',
    redirect: DASHBOARD,
  },
  {
    link: '*',
    element: Error404,
  },
]
